/**
 * Dock cameras are relayed by MediaMTX and served same-origin at /streams/
 * (nginx proxies to the media server). See deploy/mediamtx/ for the pipeline.
 * The stream path is the dock's MQTT topic_prefix, e.g. `dock-622c844e`.
 */
export function dockCamUrl(topicPrefix: string, cam: 1 | 2): string {
  return `/streams/${topicPrefix}/cam${cam}/index.m3u8`;
}

export type DockCameraSlot = 1 | 2;

/**
 * What the operator calls each slot. cam1/cam2 are the only identifiers the
 * stream pipeline records; internal/external is the labelling agreed for the
 * dock hardware.
 *
 * Field-corrected 2026-08-10: on the deployed docks cam1 looks OUTWARD and cam2
 * looks into the bay — the original agreed labelling was inverted.
 *
 * Lives beside `dockCamUrl` rather than in the sidebar because the sidebar owns
 * the buttons while the COP page owns the windows, and a slot that is "External"
 * on the button and "Internal" on the window it opened would be worse than
 * either name alone.
 */
export const DOCK_CAMERA_LABELS: Record<DockCameraSlot, string> = {
  1: 'External',
  2: 'Internal',
};
